import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('rtnPartMstStore', Object.keys(state)), // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
	...mapGetters('rtnPartMstStore', Object.keys(getters)) // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
};
export const serviceMethods = {
	...mapActions('rtnPartMstStore', Object.keys(actions)), // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
	...mapMutations('rtnPartMstStore', Object.keys(mutations)) // store에서 사용할 변수는 유일해야되기 때문에 이름을 바꾼다.
};
